import { GrowthBook } from '@growthbook/growthbook';
import { appAnalytics } from 'analytics';
import { ExperimentStarted } from 'analytics/AllEvents';
import { v4 as uuidv4 } from 'uuid';

const clientKey = process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY;

if (!clientKey) {
  console.warn(
    'GrowthBook client key is missing. Check your environment variables.',
  );
}

export const growthbook = new GrowthBook({
  apiHost: 'https://cdn.growthbook.io',
  clientKey: clientKey,
  enableDevMode: true,
  trackingCallback: (experiment: any, result: any) => {
    appAnalytics.trackEvent(new ExperimentStarted(experiment.key, result.key));
  },
});

export const getOrCreateAnonymousId = () => {
  const key = 'anonymous_user_id';
  let id = localStorage.getItem(key);

  if (!id) {
    id = uuidv4();
    localStorage.setItem(key, id);
  }
  return id;
};
